var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActualRythmLegend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#F9F8FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5H18",
    stroke: "#680DDB",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActualRythmLegend);
export default __webpack_public_path__ + "static/media/actual-rythm-legend.1b6f0a591f3b7493a441f81395983304.svg";
export { ForwardRef as ReactComponent };